import { Psychologist } from "utils/interfaces"
import { ServicesGroup } from "utils/helpers/ServicesGroup"
import { getHasSlots } from "utils/helpers/getHasSlots"

export function getBookingAvailableWithSlots(psy: Psychologist) {
    const serviceGroups = ServicesGroup.from(psy)
    return getHasSlots(serviceGroups)
}
